import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard, LogoutGuard } from './helper/guard/login.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DefaultComponent } from './layouts/default/default.component';
import { ReportAnalysisComponent } from './modules/report/report-analysis/report-analysis.component';
import { TokenDisplayComponent } from './layouts/token-display/token-display.component';
import { UrlServices } from './helper/class/url-services';
import { LicenseGuard } from './helper/guard/license.guard';


export class AppResolver {
  resolve() {
    const promise = new Promise((resolve, reject) => {
      resolve(true);
    });
    return promise;
  }
}


const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./core/module/Auth/Auth.module').then(m => m.AuthModule),
        canActivate: [LogoutGuard]
      },
    ]
  },
  {
    path: UrlServices.DISPLAY_ROUTE,
    component: TokenDisplayComponent,
    'pathMatch': 'full'
  },
  {
    path: '',
    component: DefaultComponent,
    children: [
      {
        path: '', loadChildren: () => import('./modules/modules.module').then(m => m.ModulesModule),
        // canActivate: [LoginGuard, LicenseGuard],
        // canActivateChild: [LicenseGuard]
      },
    ]
  },

];

@NgModule({
  providers: [AppResolver],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [DefaultComponent, AuthLayoutComponent];

